import { render } from "./AppTable.vue?vue&type=template&id=086e5400&scoped=true&ts=true"
import script from "./AppTable.ts?vue&type=script&lang=ts"
export * from "./AppTable.ts?vue&type=script&lang=ts"

import "./AppTable.vue?vue&type=style&index=0&id=086e5400&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-086e5400"]])

export default __exports__